import { defineMessages } from "react-intl"

export const messages = defineMessages({
  authenticAccountId: {
    id: "settings.authentic-account-id",
    defaultMessage: "0"
  }
})

export default messages



// WEBPACK FOOTER //
// ./webapp/messages/settings.js